import { createAsyncThunk } from '@reduxjs/toolkit';
import { kpiService } from '../../../services/src/service/analytics/kpi.service';
import {
  GroupedKpiMetricResponse,
  IGetGroupedKpiMetricProps,
  IGetKpiMetricProps,
  IGetRevenueDistributionProps,
  KpiMetricResponse,
  RevenueDistributionResponse,
} from '../../../services/src/service/types/analytics/analytics';
import { KpiActionTypes } from './types';
import { camelToSnakeCase } from '../utils/utils';

function remapKpiData({ product, kpiType = '' }) {
  const remappedProduct = product === 'All Syte Products' ? 'all' : product;
  const remappedKpiType = camelToSnakeCase(kpiType);
  return { remappedProduct, remappedKpiType };
}

export const kpiActions = {
  getKpi: createAsyncThunk(
    KpiActionTypes.FetchKpiMetric,
    async (
      { kpiType, shopId, timeRange, product, device }: IGetKpiMetricProps,
      { rejectWithValue }
    ) => {
      try {
        const { remappedProduct, remappedKpiType } = remapKpiData({
          product,
          kpiType,
        });
        const response: KpiMetricResponse = await kpiService.getKpiMetric({
          shopId,
          kpiType: remappedKpiType,
          timeRange,
          product: remappedProduct,
          device,
        });

        return {
          kpiType,
          data: response,
        };
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
  getGroupedKpi: createAsyncThunk(
    KpiActionTypes.FetchGroupedKpiMetric,
    async (
      {
        kpiType,
        shopId,
        timeRange,
        product,
        device,
        compareToPreviousPeriod,
      }: IGetGroupedKpiMetricProps,
      { rejectWithValue }
    ) => {
      try {
        const { remappedProduct, remappedKpiType } = remapKpiData({
          product,
          kpiType,
        });
        const response: GroupedKpiMetricResponse = await kpiService.getGroupedKpiMetric({
          shopId,
          kpiType: remappedKpiType,
          timeRange,
          product: remappedProduct,
          device,
          compareToPreviousPeriod,
        });
        return {
          kpiType,
          data: response.data,
        };
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
  getRevenueDistribution: createAsyncThunk(
    KpiActionTypes.FetchRevenueDistribution,
    async (
      { shopId, timeRange, product, device }: IGetRevenueDistributionProps,
      { rejectWithValue }
    ) => {
      try {
        const { remappedProduct } = remapKpiData({
          product,
        });
        const response: RevenueDistributionResponse = await kpiService.getRevenueDistribution({
          shopId,
          timeRange,
          product: remappedProduct,
          device,
        });
        return {
          product: remappedProduct,
          data: response.data,
        };
      } catch (error) {
        return rejectWithValue({ error });
      }
    }
  ),
};
